import { getDeployment } from '../utils/getDeployment';
import { getUrl } from '../utils/getUrl';

export const headers =
  getDeployment() === 'production'
    ? {}
    : { Authorization: `Basic ${process.env.API_KEY}` };

export const getAccount = (handle: string) =>
  fetch(`${getUrl()}/api/account/${handle}`, {
    headers,
  }).then((res) => res.json());

export const getFilter = (handle: string) =>
  fetch(`${getUrl()}/api/account/${handle}/filter`, {
    headers,
  }).then((res) => res.json());

export const getSources = (handle: string) =>
  fetch(`${getUrl()}/api/account/${handle}/source`, {
    headers,
  }).then((res) => res.json());

export const getLinks = (handle: string) =>
  fetch(`${getUrl()}/api/account/${handle}/links`, {
    headers,
  }).then((res) => res.json());
